<template>
  <div>
    <!-- 위험등록부 목록 -->
    <c-table
      ref="table"
      title="LBL0001203"
      tableId="riskRegister01"
      :columns="gridRisk.columns"
      :data="riskReduce.riskbooks"
      :merge="gridRisk.merge"
      :gridHeight="setheight"
      :editable="editable && !disabled"
      selection="multiple"
      rowKey="ramSignificantRiskRegisterId"
      checkDisableColumn="riskRegisterFlag"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable && !disabled"
            label="LBLREMOVE"
            icon="remove"
            @btnClicked="removeRisk"
          />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'riskHazardPicture'">
          <q-btn
            unelevated
            round
            dense
            size="7px"
            color="primary"
            icon="wallpaper"
            @click.stop="openHazardPicture(props)"
          />
        </template>
        <template v-else-if="col.name === 'picture'">
          <q-btn
            unelevated
            round
            dense
            size="7px"
            color="primary"
            icon="wallpaper"
            @click.stop="openImprPicture(props)"
          />
        </template>
        <template v-else-if="col.name === 'customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="editable && !disabled"
            :requestContentsCols="requestContentsCols"
            tableKey="ram4mAssessScenarioId"
            ibmTaskTypeCd="ITT0000023"
            ibmTaskUnderTypeCd="ITTU000030"
            @imprChange="imprChange"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "fm-risk-register",
  props: {
    param: {
      type: Object,
      default: function () {
        return {
          ramRiskAssessmentPlanId: "",
          ramStepCd: "",
        };
      },
    },
    riskReduce: {
      type: Object,
      default: function () {
        return {
          imprs: [],
          riskbooks: [],
        };
      },
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      gridRisk: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "processJob" },
          // { index: 2, colName: 'ram4mRiskHazardClassGroup' },
          // { index: 3, colName: 'ram4mRiskHazardClassGroup' },
          // { index: 4, colName: 'ram4mRiskHazardClassGroup' },
          // { index: 5, colName: 'ram4mRiskHazardClassGroup' },
          // { index: 6, colName: 'ram4mRiskHazardClassGroup' },
          // { index: 7, colName: 'ram4mRiskHazardClassGroup' },
        ],
        columns: [
          {
            name: "processName",
            field: "processName",
            label: "공정",
            align: "left",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "단위작업(순서)",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "ram4mRiskHazardClassName",
            field: "ram4mRiskHazardClassName",
            // 평가구분(4M)
            label: "LBL0001112",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          // {
          //   name: 'riskHazardPicture',
          //   field: 'riskHazardPicture',
          //   // 사진
          //   label: 'LBL0001175',
          //   align: 'center',
          //   style: 'width:40px',
          //   sortable: false,
          //   type: 'custom',
          // },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            // 유해위험요인
            label: "LBL0001050",
            align: "left",
            style: "width:170px",
            sortable: false,
          },
          // {
          //   name: 'relationLaw',
          //   field: 'relationLaw',
          //   // 관련법규
          //   label: 'LBL0001021',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          // {
          //   name: 'damageTargetName',
          //   field: 'damageTargetName',
          //   // 피해대상
          //   label: 'LBL0001185',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          {
            name: "damageTypeNameName",
            field: "damageTypeNameName",
            // 재해형태
            label: "LBL0001186",
            align: "left",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "existingRiskManagementActivities",
            field: "existingRiskManagementActivities",
            label: "현재안전조치<br/>현재관리방법",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "before",
            field: "before",
            label: "현재위험도",
            align: "center",
            child: [
              {
                name: "beforeFrequency",
                field: "beforeFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeStrength",
                field: "beforeStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeRisk",
                field: "beforeRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          // {
          //   name: 'picture',
          //   field: 'picture',
          //   // 개선<br/>전/후<br/>사진
          //   label: 'LBL0001176',
          //   align: 'center',
          //   type: 'custom',
          //   style: 'width:70px',
          //   sortable: false,
          // },
          {
            name: "addingRiskManagementActivities",
            field: "addingRiskManagementActivities",
            // 추가 리스크관리 계획
            label: "개선방향(대책)",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "improveFlagName",
            field: "improveFlagName",
            label: "개선진행여부",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "impr",
            field: "impr",
            // 개선진행
            label: "LBL0001178",
            align: "center",
            child: [
              {
                name: "customCol",
                field: "customCol",
                label: "LBLIMPRNO_PROGRESS",
                align: "center",
                style: "width:150px",
                type: "custom",
                sortable: false,
              },
            ],
          },
          {
            name: "after",
            field: "after",
            label: "개선후 위험도",
            align: "center",
            child: [
              {
                name: "afterFrequency",
                field: "afterFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterStrength",
                field: "afterStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterRisk",
                field: "afterRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: "assessDate",
            field: "assessDate",
            // 평가일
            label: "LBL0001013",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "assessUserName",
            field: "assessUserName",
            // 평가자
            label: "LBL0001014",
            align: "center",
            userId: "assessUserId",
            style: "width:80px",
            sortable: false,
          },
        ],
        data: [],
        height: "500px",
      },
      colorItems: [],
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
      requestImprRow: null,
      imprData: null,
      editable: true,
      deleteUrl: "",
    };
  },
  computed: {
    setheight() {
      let pxRemove = this.height.replace("px", "");
      return this.height && this.height.indexOf("px") > -1 && !isNaN(pxRemove)
        ? Number(pxRemove) - 50 + "px"
        : "500px";
    },
    disabled() {
      return this.param.ramStepCd === "RRS0000015";
    },
    imprComponent() {
      let components = null;
      if (!this.param.vendorFlag) {
        components = () => import(`${"@/pages/common/ibm/tableImpr.vue"}`);
      } else {
        components = () => import(`${"@/pages/ram/4m/4mTableImpr.vue"}`);
      }
      return components;
    },
    requestContentsCols() {
      return ["jobName", "ram4mRiskHazardClassName", "riskHazardName"];
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.deleteUrl = this.$format(
        transactionConfig.ram.riskRegister.delete.url,
        "ITT0000023"
      );
      // code setting
      // this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
      //   this.colorItems = _result
      // });
      // list setting
    },
    research() {
      this.$emit("research");
    },
    /* eslint-disable no-unused-vars */
    imprChange(data) {
      this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
      this.$emit("getList");
    },
    removeRisk() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGREMOVE", // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            let deleteData = [];
            this.$_.forEach(selectData, (item) => {
              deleteData.push({
                ramSignificantRiskRegisterId: item.ramSignificantRiskRegisterId,
                ramRiskAssessmentPlanId: item.ramRiskAssessmentPlanId,
                processCd: item.processCd,
                scenarioId: item.ram4mAssessScenarioId,
              });
            });
            this.$http.url = this.deleteUrl;
            this.$http.type = "DELETE";
            this.$http.param = {
              data: Object.values(deleteData),
            };
            this.$http.request(() => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
              this.$_.forEach(selectData, (item) => {
                this.riskReduce.riskbooks.splice(
                  this.$_.findIndex(this.riskReduce.riskbooks, {
                    ramSignificantRiskRegisterId:
                      item.ramSignificantRiskRegisterId,
                  }),
                  1
                );
              });
              this.$refs["table"].$refs["compo-table"].clearSelection();
              this.research();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    openHazardPicture(props) {
      this.popupOptions.title = "LBL0001110"; // 유해위험요인 사진
      this.popupOptions.param = {
        ram4mAssessScenarioId: props.row.ram4mAssessScenarioId,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/hazard/riskHazardPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPicturePopup;
    },
    closeHazardPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openImprPicture(props) {
      this.popupOptions.title = "LBL0001181"; // 개선 사진
      this.popupOptions.param = {
        ram4mAssessScenarioId: props.row.ram4mAssessScenarioId,
        sopImprovementIds: props.row.sopImprovementIds,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/4m/action/4mScenarioImprPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeScenarioImprPicturePopup;
    },
    closeScenarioImprPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
